import React, {Component} from "react"
import {PartialRoute} from "@irati/utils/history/routing"

import {LangLoader} from "@irati/utils/lang"
import {ACCOUNT, ONBOARDING} from "@irati-web/app/src/routeConfig"

import {getQuery} from "../helpers/getOnboardingQuery"
import OnboardContainer from "../containers/OnboardContainer"
import RequestNewLink from "../containers/V2/RequestNewLink"
import MalformedLink from "../containers/MalformedLink"
import UserOnboarding from "../containers/V4/UserOnboarding"

interface Props {
  path: string
}

const Routes: React.FC<Props> = () => {
  const {token, uuid, code} = getQuery()
  let Comp: any = UserOnboarding
  // if we have a token, its a v2 url
  if (token) {
    Comp = RequestNewLink
  } else if (!uuid || !code) {
    // if we don't have a uuid or code it's a malformed url
    Comp = MalformedLink
  }

  return (
    <LangLoader buckets={[ONBOARDING, ACCOUNT]}>
      <OnboardContainer>
        <Comp />
      </OnboardContainer>
    </LangLoader>
  )
}

class Onboarding extends Component<Props> {
  render() {
    const {path} = this.props

    return <PartialRoute path={path} noauth component={Routes} />
  }
}

export default Onboarding
